module.exports = __webpack_public_path__ + "img/thermometer.ced6c473.svg";